<template>
    <el-col :xs="12" :sm="5" :md="3" :lg="3" :xl="3">
        <a type="button" @click="filterStatus(filter_status)" style="cursor:pointer;" >
            <el-card class="total" :class="{ 'card-active': is_active.includes(filter_status[0]) }" shadow="always" type="danger" body-style="padding:10px;height: -webkit-fill-available;display: grid; justify-content: center; align-items: center">
                <div class="text text-total">Total</div>
                <div class="text amount-total">{{ ammount }}</div>
            </el-card>
        </a>
    </el-col>
</template>

<script>
    export default {
        name: "QuadroOnboarding",
        props: ['ammount', 'filter_status', 'is_active'],
        methods: {
            filterStatus(status) {
                this.$emit('handleValue', status);
            }
        }
        
    }
</script>  
<style scoped>
    .total{
        color: #177C15;
        height:195px;
    }
    .total .el-card__body{
        height: -webkit-fill-available;
    }
    .amount-total{
        font-size:50px;
    }
    .text-total{
        font-size:25px;
    }
    .card-active{
        background-color: #8D8D8D;
    }
    .el-card .is-always-shadow{
        min-height: auto !important;
        margin: 5px;
    }
    .el-card .el-card__body .text{
        text-align: center !important;
        font-weight: bolder;
    }
</style>